import React, { useState } from 'react';
import { Alert, Box, Chip, Grid, Paper, TextField, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { HEALTH_ITEMS, getHealthDetailIssues } from './enrollmentHealthModel';

const YesNo = ({ label, value, onChange }) => <ToggleButtonGroup
  exclusive size="small" value={value || 'nao'} onChange={(_, next) => { if (next) onChange(next); }}
  aria-label={label} sx={{ flexShrink: 0, '& .MuiToggleButton-root': { px: 2, textTransform: 'none', fontWeight: 600 }, '& .Mui-selected': { color: 'primary.main', bgcolor: '#e6f1ff' } }}
>
  <ToggleButton value="nao" aria-label={`Não para ${label}`}>Não</ToggleButton>
  <ToggleButton value="sim" aria-label={`Sim para ${label}`}>Sim</ToggleButton>
</ToggleButtonGroup>;

export default function EnrollmentHealth({ form, errors = {}, onFieldChange }) {
  const [filter, setFilter] = useState('all');
  const [editingDetail, setEditingDetail] = useState(null);
  const selected = HEALTH_ITEMS.filter(item => form[item.field] === 'sim');
  const issues = getHealthDetailIssues(form);
  const visible = HEALTH_ITEMS.filter(item => filter === 'all' || (filter === 'yes' ? form[item.field] === 'sim' : issues.includes(item) || item.detail === editingDetail));
  return <Box>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>Confira cada item e marque Sim quando se aplicar. Os detalhes aparecem no próprio cartão; alternar a resposta não apaga o que você digitou.</Typography>
    <Box display="flex" flexWrap="wrap" gap={1} alignItems="center" mb={2}>
      {[['all', `Todos (${HEALTH_ITEMS.length})`], ['yes', `Respostas Sim (${selected.length})`], ['missing', `Detalhes a completar (${issues.length})`]].map(([value, label]) =>
        <Chip key={value} label={label} clickable color={filter === value ? 'primary' : 'default'} variant={filter === value ? 'filled' : 'outlined'}
          onClick={() => setFilter(value)} aria-pressed={filter === value} />)}
    </Box>
    {!visible.length && <Alert severity="info">Nenhum item neste filtro. Selecione Todos para conferir as perguntas.</Alert>}
    <Grid container spacing={1.5}>
      {visible.map(item => {
        const yes = form[item.field] === 'sim';
        const missing = yes && item.detail && !String(form[item.detail] || '').trim();
        return <Grid item xs={12} md={6} key={item.field}>
          <Paper component="section" aria-label={item.label} variant="outlined" sx={{ p: 2, height: '100%', boxSizing: 'border-box', borderRadius: 2, borderColor: missing ? 'warning.light' : yes ? 'primary.light' : 'divider', bgcolor: yes ? '#f5f9ff' : 'background.paper' }}>
            <Box display="flex" alignItems="center" justifyContent="space-between" gap={1.5}>
              <Typography fontWeight={600} variant="body2">{item.label}</Typography>
              <YesNo label={item.label} value={form[item.field]} onChange={value => onFieldChange(item.field, value)} />
            </Box>
            {item.description && <Typography variant="caption" color="text.secondary">{item.description}</Typography>}
            {yes && item.detail && <TextField fullWidth required size="small" sx={{ mt: 2 }} label={item.detailLabel}
              id={`requerimento-campo-${item.detail}`} name={item.detail} onFocus={() => setEditingDetail(item.detail)} onBlur={() => setEditingDetail(null)} value={form[item.detail] || ''} onChange={e => onFieldChange(item.detail, e.target.value)}
              error={Boolean(errors[item.detail])} helperText={errors[item.detail] ? 'Campo obrigatório' : missing ? 'Complete esta informação.' : ''} />}
            {yes && item.treatment && <Box sx={{ mt: 2 }} display="flex" justifyContent="space-between" alignItems="center" gap={1}>
              <Typography variant="body2">Está em tratamento?</Typography>
              <YesNo label={`Tratamento para ${item.label.toLowerCase()}`} value={form[item.treatment]} onChange={value => onFieldChange(item.treatment, value)} />
            </Box>}
          </Paper>
        </Grid>;
      })}
    </Grid>
  </Box>;
}
